<template>
    <div style="width: 100%;">
        <v-autocomplete :item-text="itemText"
                        :item-value="itemValue"
                        :items="list"
                        :v-model="selected"
                        :label="label"></v-autocomplete>
    </div>
</template>

<script>
    export default {
        props: ["label", "list", "selected"],
        components: {
        },
        data() {
            return {
            }
        },
        methods: {
            itemText: (item) => item.lang00,
            itemValue: (item) => item,
        }
    }
</script>

<style scoped>
</style>